
import React, {Component} from 'react';
import {Input, Button, Card, Row, Col, Form, Select} from 'antd';

const {Option} = Select;
const {Item: FormItem} = Form;

class Admin extends Component {
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 4,
                },
            },
        };

        const { getFieldDecorator } = this.props.form;
        const {onSubmit, admin, form} = this.props;
        const getDefaultVal = (key) => {
            return (admin && admin[key]) || '';
        };
        const handleSubmit = (e) => {
            e.preventDefault();
            return form.validateFieldsAndScroll((err, values) => {
                if (err) {
                    return;
                }
                return onSubmit(values);
            });
        };
        const isEdit = () => {
            return admin && !admin.draft;
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>{isEdit() ? 'Edit': 'New Admin'} Details</span>
            </div>
        );

        const onCancel = (e) => {
            return this.props.onCancel(e);
        };

        return (
            <Card title={title()} loading={this.props.isFetching} bordered={false}>
                <Row style={{ marginTop: '10px' }} gutter={16}>
                    <Col md={{span: 18, offset: 3}}>
                        <Form onSubmit={handleSubmit}>
                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label={(
                                    <span>Name</span>
                                )}
                            >
                                {getFieldDecorator('name', {
                                    initialValue: getDefaultVal('name'),
                                    rules: [{ required: true, message: 'Please input your name!', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Job Title"
                            >
                                {getFieldDecorator('job_title', {
                                    initialValue: getDefaultVal('job_title'),
                                    rules: [{ required: true, message: 'Please input your job title', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback={!isEdit()}
                                {...formItemLayout}
                                label="E-mail"
                            >
                                {getFieldDecorator('email', {
                                    initialValue: getDefaultVal('email'),
                                    rules: [{
                                        type: 'email', message: 'The input is not valid E-mail!',
                                    }, {
                                        required: !isEdit(), message: 'Please input your E-mail!', whitespace: true,
                                    }],
                                })(
                                    <Input disabled={isEdit()}/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Phone Number"
                            >
                                {getFieldDecorator('phone_number', {
                                    initialValue: getDefaultVal('phone_number'),
                                    rules: [
                                        { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                        { required: true, message: 'Please input your phone number!', whitespace: true }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Permission"
                            >
                                {getFieldDecorator('permission', {
                                    initialValue: '1'
                                })(
                                    <Select>
                                        <Option value="1">All</Option>
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem {...tailFormItemLayout}>
                                <Button size='large' onClick={onCancel} style={{marginRight: 10}}>Cancel</Button>
                                <Button size='large' type="primary" htmlType="submit">Submit</Button>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </Card>
        );
    }
}

const WrappedForm = Form.create()(Admin);
export default WrappedForm;


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/Admin.js